import { render, staticRenderFns } from "./RegResultPageSocial.vue?vue&type=template&id=10a9ea76"
import script from "./RegResultPageSocial.vue?vue&type=script&lang=js"
export * from "./RegResultPageSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports